import ghgImage from "../../../assets/design-revamp-company/company-component/ghg-protocol.svg";
import ghgImageDa from "../../../assets/design-revamp-company/company-component/ghg-protocol-da.svg";
import backButton from "../../../assets/design-revamp-company/company-component/Back_Button.svg";
import { useState } from "react";
import Modal from "../CompanyModal";
import { useTranslation } from "react-i18next";

const GHGProtocolModal = () => {
  const [isOpen, setIsOpen] = useState();
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        maxWidth: "80vw",
      }}
    >
      <div className="modal-line"></div>
      <img
        src={currentLanguage === "en" ? ghgImage : ghgImageDa}
        alt="GHG Protocol"
        onClick={openModal}
        style={{ cursor: "pointer", width: "100%" }}
      />
      <div className="modal-line"></div>
      {isOpen && (
        <Modal
          imageSrc={currentLanguage === "en" ? ghgImage : ghgImageDa}
          altText="GHG Protocol"
          onClose={closeModal}
          closeBtn={backButton}
          closeBtnWidth={40}
          closeBtnHeight={40}
        />
      )}
    </div>
  );
};

export default GHGProtocolModal;
